export const sx = {
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '7px 8px 7px 15px',
        boxShadow: 'none',
        '.lightTheme  &': {
            backgroundColor: '#fff',
            "&:hover": {
                backgroundColor: '#e9f7ff'
            },
        },

        '&.active':{
            backgroundColor:'#0288d1',
            color:'#fff',
            "&:hover": {
                backgroundColor:'#0288d1',
                cursor:'default'
            },
        },

    },
    name: {
        '.lightTheme  &': {
            color: '#5f5f5f'
        },
        '&.active':{
            color:'#fff'
        }
    },
}